export default "__VITE_ASSET__fe896440__"